import { useState } from "react";
import React from "react";
import { Box } from "react-bulma-components";
import { Heading } from "react-bulma-components";
import { Section } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import { Form } from "react-bulma-components";
import Jobs from "./Jobs";
import Rentals from "./Rentals";
import Figures from "./Figures";
import { formatDate, getLastDayOfWeek, getFirstDayOfWeek, getFirstDayOfMonth, getLastDayOfMonth } from "../../utils";
import CourtesyCars from "./CourtesyCars";
import { Button } from "react-bulma-components";
import VehicleSales from "./VehicleSales";
import InfoModal from "./InfoModal";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import {useSelector} from "react-redux";
import {getDataFresh, getDepartmentsData, getVehiclesData} from "../../state/selectors";
import LoadingSpinner from "../Utils/Spinner";
import DepartmentPicker from "../Job/DepartmentPicker";
import ContactSection from "./ContactSection";
import SalesPrepVehicles from "./SalesPrepVehicles";
import {useVehiclesData} from "../../hooks/useVehiclesData";
import VehicleSection from "./VehicleSection";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";

function Home({ endpoint }) {
  const dataFresh = useSelector(getDataFresh);
  const [start, setStart] = useState(getFirstDayOfWeek(new Date()));
  const [infoModal, setInfoModal] = useState(false)
  const [end, setEnd] = useState(getLastDayOfWeek(start));
  const [view, setView] = useState('weekly');
  const [selectedDepartment, setSelectedDepartment] = useState(-1);


  const departmentsLoaded = useDepartmentsData({}, dataFresh);
  let departments = useSelector(getDepartmentsData);
  const onDateSelect = e => {
    view === 'weekly' ? onWeekSelect(e) : onMonthSelect(e)
  };

  const onViewChange = view => {
    setView(view);
    if (view === 'weekly') {
      setStart(getFirstDayOfWeek(start));
      setEnd(getLastDayOfWeek(start))
    } else if (view === 'monthly') {
      setStart(getFirstDayOfMonth(start));
      setEnd(getLastDayOfMonth(start))
    }
  };

  const onMonthSelect = e => {
    let first = getFirstDayOfMonth(new Date(e.target.value));
    let finish_date = getLastDayOfMonth(first);
    setStart(first);
    setEnd(finish_date);
  };

  const onWeekSelect = e => {
    let first = getFirstDayOfWeek(new Date(e.target.value));
    let finish_date = getLastDayOfWeek(first);
    setStart(first);
    setEnd(finish_date);
  };

  const onDepartmentChange = e => {
    setSelectedDepartment(e.target.value);
  }

  let dates = { start: formatDate(start), end: formatDate(end), type: view };

  if(!departmentsLoaded){
    return (
        <LoadingSpinner/>
    )
  }

  document.title = process.env.REACT_APP_DOCUMENT_TITLE;

  return (
    <Section>
      <Box>
        <Heading>Summary</Heading>
        <Heading subtitle>
          {start.toDateString()} - {end.toDateString()}
        </Heading>
        <Columns>
          <Columns.Column>
            <Form.Field className="has-addons">
              <Form.Control>
                <Form.Label>Timeframe</Form.Label>
                <Button
                  color={view === 'weekly' ? "primary" : ""}
                  onClick={() => onViewChange('weekly')}
                >
                  Weekly
                </Button>
                <Button
                  color={view ==='monthly' ? "primary" : ""}
                  onClick={() => onViewChange('monthly')}
                >
                  Monthly
                </Button>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <DepartmentSelector
              value={selectedDepartment}
              options={departments}
              onChange={onDepartmentChange}
              blank={true}
              label={"Department"}
            />
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Form.Label>Select a Date</Form.Label>
              <Form.Field className="contact-section has-addons">
                <Form.Control>
                  <Form.Input
                    type="date"
                    value={formatDate(start)}
                    name="day"
                    onChange={onDateSelect}
                  />
                </Form.Control>
              </Form.Field>
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Button
              color={"info"}
              onClick={(e) => setInfoModal(true)}
            >
              Info
            </Button>
          </Columns.Column>
        </Columns>
      </Box>
      <Figures dates={dates} endpoint={endpoint} selectedDepartment={selectedDepartment}/>
      <Columns>
        <Columns.Column>
          <ContactSection

          />
        </Columns.Column>
      </Columns>
      <Columns>
        <Columns.Column>
          <Jobs />
        </Columns.Column>
      </Columns>
      <Columns>
        <Columns.Column>
          <VehicleSales dates={dates} endpoint={endpoint}/>
        </Columns.Column>
      </Columns>
      <Columns>
        <Columns.Column>
          <Rentals dates={dates} />
        </Columns.Column>
      </Columns>
      <VehicleSection
        endpoint={endpoint}
        dataFresh={dataFresh}
      />
      <InfoModal
        show={infoModal}
        setShow={setInfoModal}
      />
    </Section>
  );
}
export default Home;
